import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Controller } from 'react-hook-form';
import { useMediaQuery } from 'react-responsive';

import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Grid from '@material-ui/core/Grid';
import { CardHeader, Box } from '@material-ui/core';
import Switch from '@material-ui/core/Switch';
import Typography from '@material-ui/core/Typography';
import { useParams } from 'react-router-dom';

const CollectionAvailability = ({ control, watch, collectionData, setValue, inline }) => {
    const { t } = useTranslation();
    const active = watch('active');
    let { id } = useParams();
    const [isCheck, setIsCheck] = useState(false)
    const isTabletOrMobile = useMediaQuery({ query: '(max-width: 600px)' });

    useEffect(() => {
        if (Object.keys(collectionData).length > 0) {
            setValue('active', collectionData.public ? true : false);
        }
        setIsCheck(Boolean(collectionData.public))
    }, [collectionData, setValue]);

    if (inline) {
        return (
            <Box display="flex" alignItems="center">
                <Controller
                    render={({ field: { value, ref, ...field } }) => (
                        <Switch
                            {...field}
                            inputRef={ref}
                            checked={!!value}
                            disableRipple
                            size="small"
                            onClick={() => setIsCheck(!isCheck)}
                        />
                    )}
                    control={control}
                    defaultValue={true}
                    name="active"
                />
                <Typography variant="caption" style={{ color: isCheck ? '#2E7D32' : '#999', fontSize: 12 }}>
                    {isCheck ? 'Activa' : 'Inactiva'}
                </Typography>
            </Box>
        );
    }

    return (
        <Card
            elevation={isTabletOrMobile ? 0 : 2}
            style={
                isTabletOrMobile
                    ? {
                          marginBottom: 12,
                          marginTop: 12,
                          borderRadius: 12,
                          border: '1px solid #E8E8E8',
                          boxShadow: '0px 1px 3px rgba(0,0,0,0.06)',
                      }
                    : { marginBottom: 21 }
            }
        >
            <CardHeader titleTypographyProps={{ variant: 'h6' }} title={t('Collection.availabilityTitle')} />
            <CardContent style={isTabletOrMobile ? { padding: '8px 16px 16px' } : undefined}>
                <Grid
                    container
                    spacing={isTabletOrMobile ? 1 : 3}>
                    <Box
                        display="flex"
                        justifyContent="space-between"
                        alignItems="center">
                        <Controller
                            render={({ field: { value, ref, ...field } }) => (
                                <Switch
                                    {...field}
                                    inputRef={ref}
                                    checked={!!value}
                                    disableRipple
                                    onClick={() => setIsCheck(!isCheck)}
                                />
                            )}
                            control={control}
                            defaultValue={true}
                            name="active"
                        />

                        {id
                            ? <Typography variant="body2">
                                {isCheck ? t('Collection.isAvailability') : t('Collection.noAvailability')}
                            </Typography>
                            : <Typography variant="body2">
                                {(!isCheck) ? t('Collection.isAvailability') : t('Collection.noAvailability')}
                            </Typography>
                        }
                    </Box>

                </Grid>

            </CardContent>
        </Card >
    );
};
export default connect()(CollectionAvailability);